import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { BorderStyleEnum, BorderType } from 'common/types/styleTypes'
import React from 'react'
import { Switcher } from 'src/editor/shared/ui-lib/switcher'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { TypedTFunctionInterface } from 'src/shared/i18next/types/typed-t-function-interface'
import { getMobileOrDesktop } from 'src/shared/utils/get-mobile-or-desktop'

const getBorderStyleChoices = (
  t: TypedTFunctionInterface,
): Array<{ content: string; value: BorderStyleEnum }> => {
  return [
    {
      content: t('settings_styles.border.style.choices.solid'),
      value: BorderStyleEnum.solid,
    },
    {
      content: t('settings_styles.border.style.choices.dotted'),
      value: BorderStyleEnum.dotted,
    },
    {
      content: t('settings_styles.border.style.choices.dashed'),
      value: BorderStyleEnum.dashed,
    },
  ]
}

interface BorderStyleControlProps {
  border: Partial<BorderType> | undefined
  mobileBorder?: Partial<BorderType> | undefined
  update: (value: Partial<BorderType>) => void
  mobileUpdate?: (value: Partial<BorderType>) => void
  label?: string | ''
}

export const BorderStyleControl = ({
  border,
  mobileBorder,
  update,
  mobileUpdate,
  label = 'website_styles_settings.border_style.label',
}: BorderStyleControlProps) => {
  const { t } = useTypedTranslation()
  const { isMobile } = useDeviceModeContext()

  const resultBorder = getMobileOrDesktop(border, mobileBorder, isMobile)
  const resultUpdate = getMobileOrDesktop(update, mobileUpdate, isMobile)

  return (
    resultBorder?.style &&
    resultBorder?.style !== BorderStyleEnum.none && (
      <Switcher
        labelText={label}
        btnList={getBorderStyleChoices(t)}
        value={resultBorder?.style || BorderStyleEnum.solid}
        update={value =>
          resultUpdate({
            ...resultBorder,
            style: value,
          })
        }
      />
    )
  )
}
